import Vue from "vue";
import { post, fetch, Del, put } from "../../../../ask/axios";
import bus from "../../../../ask/eventBus";
import { getCookie, setCookie } from "../../../../ask/cookiejs";
import menberMenu from "../../../../components/userCenter/public/menberPageMenu.vue";
import claim from "../../../../components/userCenter/public/claimClause.vue"; //理赔条款
import battery from "../../../../components/userCenter/public/batteryType.vue"; //电池种类说明

import senderAddrBox from "../../../../components/userCenter/public/senderAddrBox.vue"; //发件人地址库
import receiveAddrBox from "../../../../components/userCenter/public/receiveAddrBox.vue"; //收件人地址库
import productInfoBox from "../../../../components/userCenter/public/productInfoBox.vue"; //产品信息库

export default {
  components: {
    menberMenu,
    claim,
    battery,
    senderAddrBox,
    receiveAddrBox,
    productInfoBox
  },
  data() {
    return {
      userType: 0,//是否海外同行  客户归属类型 0：直客，1：国内同行，2：海外同行
      receiveAddressList: [], // 收件人地址
      api: {
        url: "",
        param: "",
        data: "",
        response: {},
        message: ""
      },

      titNames: "Air Freight Shipment ,Booking",
      titUrls: "/air/airList,",

      myHeaders: {
        ["X-JWT-TOKEN"]: getCookie("X-BY-EnTOKEN")
      },

      isShowPickUpGoods: false, //显示订单编辑部分还是派送信息部分

      PlanDeliveryTime2: new Date(), //货好时间，时间控件
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      IsWCA: false, // 是否WCA成员,是的客户不用收取银行手续费，不是的客户要收取银行手续费
      //-------主单信息
      Order: {
        Id: "", //订单号
        Status: 0, //订单状态
        SupplierID: "", //供应商Id
        DepartureCode: "", //起飞机场三字码，
        DepartureName: "", //起飞机场名称
        DestinationCode: "", //目的机场三字码
        DestinationName: "", //目的机场名称
        OrderServiceType: 1, //订单服务类型
        OrderWeight: "", //下单计费重
        AirCompanyCode: "", //航空公司二字码
        AirCompanyName: "", //航空公司名称
        PlanDeliveryTime: null, //货好时间
        RefNO: "", //参考号
        ShippingMark: "", //唛头
        GoodsName: "", //货物品名
        Weight: null, //下单重
        VolumeCBM: null, //下单体积
        PackageQuanlity: null, //下单件数
        CargoIDs: "", //货物种类IDs
        CargoNameCn: "普货", //货物种类中文名
        CargoNameEn: "", //货物种类英文名
        BatteryInfo: "", //电池种类
        Remarks: "", //备注信息
        Currency: 1 //币种
      },

      OrderExt: {
        StartCountryKey: "", //起始国家key
        StartCountryNameCn: "", //起始国家中文名
        StartCountryNameEn: "", //起始国家英文名
        StartProKey: "", //起始省份Key
        StartProNameCn: "shenzhen", //起始省份中文名
        StartProNameEn: "shenzhen", //起始省份英文名
        StartCityKey: "", //起始城市Key
        StartCityNameCn: "", //起始城市中文名
        StartCityNameEn: "", //起始城市英文名
        StartCityAreaKey: "", //起始区域key
        StartCityAreaNameCn: "", //起始区域中文名
        StartCityAreaNameEn: "", //起始区域英文名
        DestCountryKey: "", //目的国家key
        DestCountryNameCn: "美国", //目的国家中文名
        DestCountryNameEn: "", //目的国家英文名
        DestProKey: "", //目的省份key
        DestProNameCn: "", //目的省份中文名
        DestProNameEn: "", //目的省份英文名
        DestAddressDesc: "", //目的地信息
        DestCityKey: "", //目的城市key
        DestCityNameCn: "", //目的城市中文名
        DestCityNameEn: "", //目的城市英文名
        THChannelKey: "", //取件渠道Key
        DestSvcID: "", //DestSvcID
        IsStartCustoms: null, //是否需要起运地报关服务
        IsDestCustoms: "", //是否需要目的地清关服务

        IsBond: "", //是否购买Bond
        BondType: 0, //购买Bond类型
        BondValue: 0, //Bond货物价值
        IsrInsurance: "" //是否购买保险
      },

      //--------收发件人信息
      ContactInfo: {
        SenderName: "", //发件人姓名
        SenderCompany: "",
        SenderTelephone: "",
        SenderAddress: "",
        ReceiveName: "", //收件人姓名
        ReceiveCompany: "",
        ReceiveTelephone: "",
        ReceiveAddress: "",
        NofityName: "", //通知人姓名
        NotifyCompany: "",
        NotifyTelephone: "",
        NotifyAddress: "",
        SenderTaxNO: "", //发件人税号
        ReceiveTaxNO: "", //收件人税号
        NotifyTaxNO: "" //通知人税号
      },
      //工厂信息
      Factory: {
        FactoryContactName: '',//工厂名称
        FactoryContactTelephone: '',//电话
        FactoryContactEmail: '',//email
        FactoryAddress: '',//工厂地址
      },
      isFactory: null,//判断是不是点击的工厂
      discernBox: false,//工厂信息弹框
      discernInfoTip: false,//Quick order 弹框
      discernInfo: '',//Quick order信息
      IsSaveasDelegate: false, //是否保存为空运委托书
      IsSendAddToAddr: false, //是否加入到发件人地址库
      IsReceiveAddToAddr: false, //是否加入到收件人地址库
      chekReceive: "1", //通知人信息是否同收件人信息
      isCode: null, //判断是收件人还是通知人地址库

      //------------货物信息
      isShowText: 0, //不实现内容模块:0；货物信息:1；报关与文件:2；

      GoodVolumeList: [], //材积信息
      isShowGoodVolu: false, //是否显示材积信息列表

      //保险信息，编辑保险信息
      Insurance: {
        BuyAmount: null, //投保金额
        AmountCost: null, //计算的保险费用
        IsNeedVoucher: null //是否需要保险凭证
      },
      showModal: false, //遮罩层

      //------------报关与文件
      FeeList: [], //订单详情中的起运地报关

      // isCountryUS:false, //目的地是美国，则显示购买bond，否则不显示
      BondCost: 0, //购买bond的费用

      //随机文件
      randomFileVal: [],
      randomFileList: [], //随机文件列表
      OtherDocName: "", //其他文件输入框
      CargoDocList: [], //选中后的随机文件

      //文件上传
      upLoadData: {
        PathName: 'air/order',
        IsTempFile: false
      }, //导入文件
      fileList1: [],

      orderFeeList: [], //预估费用必收附加费集合
      LstDestFee: [], //预估费用目的地清关费用集合
      LstDestFeePackup: [], //备份

      airWeight: "", //空运费计费重量
      airPirce: "", //空运费单价
      airTotolCost: "", //空运费
      THAmount: "", //提货费
      THChargeWeight: "", //提货计费重

      isInsurFee: false, //是否显示保险费在预估费用列表
      isBondFee: false, //是否显示Bond费在预估费用列表

      //目的地派送费
      DeliverInfo: {
        PSWeight: "", //派送计费重 ,
        PSPrice: "", //派送费 ,
        PSUnitPrice: "" //派送单价
      },
      //提单费===是否有多个提单费
      THInfo: {
        THBillNo: "", //取件单号
        THWeight: "", //取件计费重
        THPrice: "", //取件费
        THUnitPrice: "", //取件单价
        IsMultiTH: "" //是否多个空运订单一起提货
      },
      //------------提货信息
      isShowPickUpGoods: false, //显示派送信息
      PlanDeliveryTime2: new Date(), //货好时间，时间控件
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },

      DeliverContact: {
        //派送单信息
        ContactName: "",
        Mobile: "",
        deliInfo: "",
        Address: ""
      },
      mergeTH: false, //是否合并取件

      //-------------------弹框信息----------------------//
      //----空运委托书弹框
      airPowerAttorneyBox: false, //空运委托书弹框是否显示
      poewrAttList: [], //空运委托书列表

      //----电池种类弹框
      batteryTypeBox: false, //电池种类弹框是否显示
      checkedBat: [], //选中的电池
      batInfos: [
        { val: "A123", label: "Dry battery (A123)" },
        { val: "PI968", label: "Pure lithium metal battery (PI968)" },
        { val: "PI965", label: "Pure lithium ion battery (PI965)" },
        {
          val: "PI969",
          label: "Lithium metal battery packed with shipment (PI969)"
        },
        {
          val: "PI966",
          label: "Lithium ion battery packed with shipment (PI966)"
        },
        {
          val: "PI970",
          label: "Shipment with built-in lithium metal battery (PI970)"
        },
        {
          val: "PI967",
          label: "Shipment with built-in lithium ion battery (PI967)"
        },
        { val: "A199", label: "Dry battery (A199)" }
      ], //电池种类
      batStrs: [], //选择的电池种类
      isShowbatStrs: false, //是否显示电池种类选择提示

      //货物保险弹框
      isBuyInsur: false, //是否购买保险
      isInsurBox: false, //货物保险弹框是否显示

      //弹框保险信息
      InsuranceBox: {
        BuyAmount: null, //投保金额
        msgInsur: "",
        msgTypeInsur: ""
      },

      //购买清关服务，Bond
      isBondBox: false,
      isBuyBondEd: false, //已经确定买了bond
      isGoodsVal: false, //是否输入货物价值
      BondValBk: null, //Bong 货物价值备份

      //选择提货单
      THOrderNoBox: false, //空运委托书弹框是否显示
      airOrderThList: [],

      ThLoading: true,
      ThNoData: false,

      OrderAmount: null, //下单时的金额 运费+必收附加费+选择的附加费 ,

      //合并取件单对象
      mergeInfo: { THOrderNo: "", PlanCargoDate: "" },

      isShow03: false, //起运地报关选中是  提示至少选一种报关方式
      isShow02: false, //清关服务报关未选中

      isShowOrderBtn: true, //显示提交订单按钮

      PicreInfo: "", //查价数据
      OrderServiceType: "", // 订单类型
      fileSwitch: false,//文件类型开关
      checkInfoDif: null,//notify切换存储
    };
  },

  created() {
    this.getOrderInfoApi();

    bus.$on("IsWCA", msg => {
      this.IsWCA = msg;
    });
  },
  mounted() {
    this.getValidation(); //验证调取
    this.setConsigneeInfo()
  },
  watch: {
    'ContactInfo.ReceiveCompany': 'getSameAsConsignee',
    'ContactInfo.ReceiveTaxNO': 'getSameAsConsignee',
    'ContactInfo.ReceiveName': 'getSameAsConsignee',
    'ContactInfo.ReceiveAddress': 'getSameAsConsignee',
    'ContactInfo.ReceiveTelephone': 'getSameAsConsignee',
  },
  computed: {
    //计算属性
    //计算保险
    insurCost() {
      let num = 0;
      if (this.InsuranceBox.BuyAmount && Number(this.InsuranceBox.BuyAmount)) {
        num = this.InsuranceBox.BuyAmount * 0.0018;
      }
      // this.InsuranceBox.AmountCost = num
      return num;
    },
    //计算购买一次bond费用
    bondFee() {
      let num = 0;
      if (this.OrderExt.BondValue) {
        num = this.OrderExt.BondValue * 0.005;
        if (num < 50) {
          num = 50;
        }
      } else {
        num = 50;
      }
      return num;
    },
    //预估费用
    costAll() {
      let sumNum = 0; //总费用
      let num = 0; //必收附加费+勾选附加费
      let DesCost = 0; //目的地清关费用

      if (this.orderFeeList.length > 0) {
        this.orderFeeList.forEach(e => {
          num += Number(e.Amount);
        });
      }

      if (this.LstDestFee.length > 0) {
        this.LstDestFee.forEach(e => {
          DesCost += Number(e.Amount);
        });
      }

      //this.airTotolCost 空运费用
      //this.THAmount 提货费
      sumNum =
        num +
        DesCost +
        Number(this.airTotolCost) +
        Number(this.DeliverInfo.PSPrice) +
        Number(this.THAmount) +
        Number(this.Insurance.AmountCost) +
        Number(this.BondCost);

      return sumNum;
    },

    //Bank Charge 计算：固定收费标准为：上述所有预估费用*5%，最高不超过50USD/票。
    BankCharge() {
      let sum = 0;
      if (this.costAll > 0) {
        sum = this.costAll * 0.05;
      }
      if (sum > 50) {
        sum = 50;
      }
      return sum;
    }
  },
  //方法
  methods: {
    // 选择 same as consignee时监听
    getSameAsConsignee() {
      if (this.chekReceive == "1") {
        this.ContactInfo.NofityName = this.ContactInfo.ReceiveName;
        this.ContactInfo.NotifyCompany = this.ContactInfo.ReceiveCompany;
        this.ContactInfo.NotifyTelephone = this.ContactInfo.ReceiveTelephone;
        this.ContactInfo.NotifyAddress = this.ContactInfo.ReceiveAddress;
        this.ContactInfo.NotifyTaxNO = this.ContactInfo.ReceiveTaxNO;
      }
    },
    // consignee默认填写
    setConsigneeInfo() {
      let airOrderConsigneeInfo = JSON.parse(getCookie('airOrderConsigneeInfo'))
      //获取用户信息
      let U_info = JSON.parse(sessionStorage.getItem("customerInfos"));
      console.log(airOrderConsigneeInfo, "’airOrderConsigneeInfo", U_info);
      if (airOrderConsigneeInfo) {
        this.ContactInfo.ReceiveName = airOrderConsigneeInfo.ReceiveName
        this.ContactInfo.ReceiveCompany = airOrderConsigneeInfo.ReceiveCompany
        this.ContactInfo.ReceiveTelephone = airOrderConsigneeInfo.ReceiveTelephone
        this.ContactInfo.ReceiveAddress = airOrderConsigneeInfo.ReceiveAddress
        this.ContactInfo.ReceiveTaxNO = airOrderConsigneeInfo.ReceiveTaxNO
      } else {
        this.ContactInfo.ReceiveName = U_info.CompanyContact
        this.ContactInfo.ReceiveCompany = U_info.CustomerName
      }
    },
    // 订单服务类型
    getOrderServiceType(type) {
      let typeList = [
        { type: 1, text: "Door to Door" },
        { type: 2, text: "Door to Terminal" },
        { type: 3, text: "Terminal to Terminal" },
        { type: 4, text: "Terminal to Door" },
        { type: 5, text: "FOB" },
        { type: 6, text: "EXW" },
        { type: 7, text: "FCA" }
      ];
      let typeShow = typeList.filter(item => {
        return item.type == type;
      });
      return typeShow[0].text;
      // return typeList.get(type);
    },
    //验证调取
    getValidation() {
      $("#airEditValidation").validationEngine();
      console.log($("#airEditValidation").validationEngine(), $("#airEditValidation"), '$("#airEditValidation").validationEngine()');
    },
    getCheckForm() {
      return $("#airEditValidation").validationEngine("validate");
      //$('#form1').validationEngine('validate')
    },
    //---------------------------------编辑订单详情接口数据------------------------//
    getOrderInfoApi() {
      let that = this;
      // 判断是否是以条款（FCA/FOB等）下单，即用户是海外同行
      that.userType = JSON.parse(sessionStorage.getItem("customerInfos"))
        .CustomerOwnerType;
      if (that.userType == 2) {
        this.api.url =
          this.$api04 +
          "/Air/api/AirOrderEn/GetOrderInfo?Id=" +
          this.$route.query.ord;
      } else {
        this.api.url =
          this.$api03 +
          "/api/TradeCustomer/AirOrderEn/GetOrderInfo/" +
          this.$route.query.ord;
      }
      fetch(this.api.url).then(function (res) {
        if (res.IsOK == true) {
          that.Order = res.Results.Order; //主单信息
          that.OrderExt = res.Results.OrderExt; //扩展表
          //console.log("主单信息======", that.Order, res.Results);

          // 获取服务类型
          that.OrderServiceType = that.getOrderServiceType(
            that.Order.OrderServiceType
          );

          //是否购买清关服务转化
          if (res.Results.OrderExt.IsDestCustoms == false) {
            that.OrderExt.IsDestCustoms == 1;
          } else if (res.Results.OrderExt.IsDestCustoms == true) {
            that.OrderExt.IsDestCustoms == 2;
          } else {
            that.OrderExt.IsDestCustoms == null;
          }
          if (that.OrderExt.IsBond == false) {
            that.OrderExt.BondType = 0; //购买Bond类型
            that.OrderExt.BondValue = 0; //Bond货物价值
          } else if (
            that.OrderExt.IsBond == true &&
            that.OrderExt.BondType == 2
          ) {
            that.OrderExt.BondValue = 0; //Bond货物价值
          }

          if (res.Results.ContactInfo) {
            that.ContactInfo = res.Results.ContactInfo; //联系人信息
          }

          if (that.userType == 2 || that.userType == 3) {
            //填充工厂信息
            // if (res.Results.Factory) {
            //   that.Factory = res.Results.Factory
            // }
            //海外同行 对接客户 发货人 填充 Freightshop 公司的相关信息
            that.ContactInfo.SenderName = "MR.VINCENT";
            that.ContactInfo.SenderCompany = "FREIGHTSHOP TECHNOLOGY CO.,LTD";
            that.ContactInfo.SenderTelephone = "86-13798479219";
            that.ContactInfo.SenderAddress =
              "ROOM 2701,FLOOR 27,BLOCK A,WORLD TRADE PLAZA,FUHONG RD,FUTIAN DISTRICT,SHENZHEN";
            that.ContactInfo.SenderTaxNO = "91440300094057744B";

            // 收件人信息
            // let url = that.$api02 + "/api/EbayCustomer/Addressee/List";
            // let url = that.$api04 + "/Basics/api/Addressee/List";
            // post(url, {
            //   Page: 1,
            //   Size: 99999
            // })
            //   .then(res => {
            //     if (res.IsOK && res.Results) {
            //       // 判断是否存在收件人信息
            //       const addressData = res.Results;
            //       that.receiveAddressList = addressData;
            //       if (addressData.length <= 0) {
            //         // 不存在
            //         that.IsReceiveAddToAddr = true;

            //       } else {
            //         // 存在 取第一条信息
            //         that.ContactInfo.ReceiveName = addressData[0].Address_Name;
            //         that.ContactInfo.ReceiveCompany = addressData[0].company;
            //         that.ContactInfo.ReceiveTelephone =
            //           addressData[0].Address_Tel;
            //         that.ContactInfo.ReceiveAddress =
            //           addressData[0].Address_Street;
            //         that.ContactInfo.ReceiveTaxNO =
            //           addressData[0].Address_ZIPCode;
            //         // // 通知人， 默认勾选same as consignee, 同收件人信息
            //         // that.chekReceive = true;
            //         // that.chgReceiveInfo();
            //       }
            //       // 通知人， 默认勾选same as consignee, 同收件人信息
            //       that.chekReceive = "1";
            //       that.chgReceiveInfo();
            //     }
            //   })
            //   .catch(err => {
            //     console.log(err);
            //   });
          }
          //  }
          if (res.Results.GoodVolumeList.length > 0) {
            //材积信息
            that.GoodVolumeList = res.Results.GoodVolumeList;
          }
          //客户自己选择的电池种类
          if (res.Results.Order.BatteryInfo) {
            that.batStrs = res.Results.Order.BatteryInfo.split(",");
          }
          that.isBuyInsur = that.OrderExt.IsrInsurance; //是否购买保险
          if (res.Results.Insurance) {
            //保险信息
            that.Insurance = res.Results.Insurance;

            //计算保险费用
            if (res.Results.Insurance.BuyAmount) {
              let num = 0;
              num = res.Results.Insurance.BuyAmount * 0.0018;
              if (num < 50) {
                num = 50;
              }
              that.Insurance.AmountCost = num;
            }
            if (that.Insurance.AmountCost > 0) {
              that.isInsurFee = true;
            }
          }
          //起运地报关
          if (res.Results.FeeList) {
            that.FeeList = res.Results.FeeList;
          }

          //是否购买Bond isBuyBondEd
          //如果Bond的值是0的话  设置为null
          if (res.Results.OrderExt.BondValue == 0) {
            that.OrderExt.BondValue = 0;
          } else if (res.Results.OrderExt.BondValue > 0) {
            that.BondValBk = res.Results.OrderExt.BondValue;
          }

          that.OrderExt.IsDestCustoms =
            res.Results.OrderExt.IsDestCustoms == true ? 2 : 1; //是否需要目的地清关服务
          if (res.Results.OrderExt.BondType == 1) {
            that.isBuyBondEd = true;
            if (res.Results.OrderExt.BondValue * 0.005 < 50) {
              that.BondCost = 50;
            } else {
              that.BondCost = res.Results.OrderExt.BondValue * 0.005;
            }
          }
          if (res.Results.OrderExt.BondType == 2) {
            that.isBuyBondEd = true;
            that.BondCost = 500;
          }
          //随机文件 randomFileList
          if (res.Results.CargoDocList.length > 0) {
            that.CargoDocList = res.Results.CargoDocList;
          }

          //附件
          if (res.Results.AttachList.length > 0) {
            res.Results.AttachList.forEach(e => {
              let info = {
                OriginaFilelName: e.OriginName,
                BuildFileName: e.BuildName,
                FIlePath: e.Url,
                OriginUrl: e.OriginUrl,
                AttachType: e.AttachType, //1：提单附件，2：报关底单，3：保险凭证，4：其他，5：订单资料，6，客户上传附件，通过接口上传的，没有固定哪个类型，都当订单资料类型处理
                UploadType: e.UploadType //上传人.0：客户上传，1：后台上传，2：供应商上传
              };
              that.fileList1.push(info);
            });
          }
          //订单状态为已确认的时候 Order.Status==1
          if (res.Results.Order.Status == 1) {
            //运费
            that.airWeight = res.Results.Order.ChargeWeight;
            that.airPirce = res.Results.Order.OrderPrice;
            that.airTotolCost = res.Results.Order.OrderTrafficAmount;
            //提货费
            if (res.Results.THInfo) {
              // that.THInfo=res.Results.THInfo
              that.THAmount = res.Results.THInfo.THPrice;
            }
            //目的地派送费
            if (res.Results.DeliverInfo) {
              that.DeliverInfo = res.Results.DeliverInfo;
            }
          }
          if (that.OrderExt) {
            that.DeliverContact.deliInfo =
              that.OrderExt.DestCityNameEn +
              "," +
              that.OrderExt.DestProNameEn +
              "," +
              that.OrderExt.DestCountryNameEn; //派送地址前部分
          }
          that.Order.WaybillNO = that.$route.query.ord;

          //未确认订单调用 查价接口获取运费，取件费，目的地费用，必收附加费
          that.getWillReapFee(res.Results);
        }
      });
    },
    //-------------------------------收发件人，通知人信息---------------------------------//
    //空运委托书列表查询
    poewrAttListAPI() {
      let that = this;
      this.api.param = {};
      this.api.url =
        this.$api04 + "/Air/api/AirDelegate/GetDelegateInfoList";
      post(this.api.url, this.api.param).then(function (res) {
        if (res.IsOK == true) {
          that.poewrAttList = res.Results;
        }
      });
    },

    //点击我的空运委托书按钮
    clkPowerAttBtn() {
      this.poewrAttListAPI(); // 委托书接口
      this.airPowerAttorneyBox = true;
    },

    choosePowerAtt(item) {
      this.ContactInfo = item;
      this.Order.ShippingMark = item.ShippingMark;
      this.Order.GoodsName = item.GoodsName;

      this.airPowerAttorneyBox = false;
      // console.log('item   ' + JSON.stringify(item))
    },

    //发件人地址栏弹框
    clkSendAddrBox(val) {
      this.isFactory = val
      this.$refs.senderBox.clkDialog();
    },
    //发件人地址库点击选择按钮
    showMsgSender(msg) {

      if (this.isFactory == 1) {
        // 发件人地址库选择按钮赋值
        this.ContactInfo.SenderName = msg.Address_Name;
        this.ContactInfo.SenderCompany = msg.company;
        this.ContactInfo.SenderTelephone = msg.Address_Tel;
        this.ContactInfo.SenderAddress = msg.Address_Street;
        this.ContactInfo.SenderTaxNO = "";
      }
      if (this.isFactory == 2) {
        //工厂信息
        this.Factory.FactoryContactName = msg.Address_Name;
        this.Factory.FactoryContactTelephone = msg.Address_Tel;
        this.Factory.FactoryContactEmail = msg.Address_Mail;
        this.Factory.FactoryAddress = msg.Address_Street;
      }

    },
    //收件人地址栏弹框
    clkReceiveAddrBox(code) {
      this.isCode = code;
      this.$refs.receiveBox.clkDialog();
    },

    //收件人地址库点击选择按钮
    showMsgReceive(msg) {
      if (this.isCode == 1) {
        //收件人地址库选择按钮赋值
        this.ContactInfo.ReceiveName = msg.Address_Name;
        this.ContactInfo.ReceiveCompany = msg.company;
        this.ContactInfo.ReceiveTelephone = msg.Address_Tel;
        this.ContactInfo.ReceiveAddress = msg.Address_Street;
        this.ContactInfo.ReceiveTaxNO = "";
      } else if (this.isCode == 2) {
        //通知人地址库选择按钮赋值
        this.ContactInfo.NofityName = msg.Address_Name;
        this.ContactInfo.NotifyCompany = msg.company;
        this.ContactInfo.NotifyTelephone = msg.Address_Tel;
        this.ContactInfo.NotifyAddress = msg.Address_Street;
        this.ContactInfo.NotifyTaxNO = "";
        this.chekReceive = "2"
      } else if (this.isCode == 3) {
        //目的地派送地址库选择按钮赋值
        this.DeliverContact.ContactName = msg.Address_Name;
        this.DeliverContact.Mobile = msg.Address_Tel;
        this.DeliverContact.Address = msg.Address_Street;
      }

      // if (this.ContactInfo.ReceiveCompany != this.ContactInfo.NotifyCompany) {
      //   this.chekReceive = '2';
      // }
    },
    //同收件人信息
    chgReceiveInfo() {

      if (this.chekReceive == "1") {
        this.checkInfoDif = {
          NofityName: this.ContactInfo.NofityName,
          NotifyCompany: this.ContactInfo.NotifyCompany,
          NotifyTelephone: this.ContactInfo.NotifyTelephone,
          NotifyAddress: this.ContactInfo.NotifyAddress,
          NotifyTaxNO: this.ContactInfo.NotifyTaxNO,
        }
        this.ContactInfo.NofityName = this.ContactInfo.ReceiveName;
        this.ContactInfo.NotifyCompany = this.ContactInfo.ReceiveCompany;
        this.ContactInfo.NotifyTelephone = this.ContactInfo.ReceiveTelephone;
        this.ContactInfo.NotifyAddress = this.ContactInfo.ReceiveAddress;
        this.ContactInfo.NotifyTaxNO = this.ContactInfo.ReceiveTaxNO;
      } else {
        if (this.checkInfoDif) {
          this.ContactInfo.NofityName = this.checkInfoDif.NofityName;
          this.ContactInfo.NotifyCompany = this.checkInfoDif.NotifyCompany;
          this.ContactInfo.NotifyTelephone = this.checkInfoDif.NotifyTelephone;
          this.ContactInfo.NotifyAddress = this.checkInfoDif.NotifyAddress;
          this.ContactInfo.NotifyTaxNO = this.checkInfoDif.NotifyTaxNO;
        } else {
          this.ContactInfo.NofityName = ""
          this.ContactInfo.NotifyCompany = ""
          this.ContactInfo.NotifyTelephone = ""
          this.ContactInfo.NotifyAddress = ""
          this.ContactInfo.NotifyTaxNO = ""
        }

      }
    },

    //-------------------------------  货物信息 ---------------------------------//
    clkNextStep() {
      //下一步

      //显示货物信息和报关与文件
      if (this.userType == 2 || this.userType == 3) {
        this.isShowText = this.isShowText + 2;
      } else {
        this.isShowText = this.isShowText + 1;
      }
      if (this.isShowText == 2) {
        this.randomFileListAPI(); //随机文件接口
      }
    },
    //-----下单信息
    clkGoodVolList() {
      //点击下拉材积信息，有则显示，没有则不显示
      this.isShowGoodVolu = !this.isShowGoodVolu;
    },
    ////------货物信息弹框操作-----////
    //----------------产品信息地址库弹框
    clkProductBox() {
      this.$refs.productBox.clkDialog();
    },
    //-产品信息库弹框选择按钮
    showMsgProduct(msg) {
      let nameEnObj = "";
      let nameEnArr = [];
      msg.forEach(e => {
        nameEnArr.push(e.EnglishName);
      });
      nameEnObj = nameEnArr.join(",");
      this.Order.GoodsName = nameEnObj;
    },
    //-----------------电池种类弹框
    clkBatTypeBtn() {
      //点击选择电池种类
      this.checkedBat = []; //清空选择的电池种类
      this.batteryTypeBox = true;
    },
    //选择电池种类确定按钮
    cltBatInfoBtn() {
      // console.log('checkedBat ' +  JSON.stringify( this.batStrs))
      this.batStrs = this.checkedBat;
      this.batteryTypeBox = false;
    },
    //删除选中的电池
    clkDelBatIcon(index) {
      this.batStrs.splice(index, 1);
    },
    //是否包含有电池.
    includeCargos() {
      //  let isTg=false
      //  let batArr=[sysCfg.air.Cargo.porCargoID,sysCfg.air.Cargo.builtInBatID,sysCfg.air.Cargo.packedBatID,sysCfg.air.Cargo.batteryCargoID]
      //  //取两个数组的交集
      //  let arrNew=[]
      //  arrNew = batArr.filter(v => this.Order.CargoIDs.includes(v))
      //  if(arrNew.length > 0){
      //    isTg = true
      //  }
      //  return isTg

      let isTg = false;
      let batArr = [sysCfg.air.Cargo.generalCargoID, sysCfg.air.Cargo.magBatID]; //空运货物种类普货和带磁
      //取两个数组的交集
      let arrNew = [];
      arrNew = batArr.filter(v => this.Order.CargoIDs.includes(v));
      if (arrNew.length > 0) {
        isTg = false;
      } else {
        isTg = true;
      }
      return isTg;
    },
    //-----------------货物保险信息
    clkBuyInsur() {
      //购买
      this.isInsurBox = true;
      if (this.BondCost > 0) {
        this.InsuranceBox.BuyAmount = this.OrderExt.BondValue;
      }
      this.InsuranceBox.Beneficiary = this.ContactInfo.ReceiveCompany;
    },
    clkCancelInsur() {
      //取消购买
      //清空购买数据
      this.InsuranceBox.BuyAmount = null;
      this.InsuranceBox.BenefitType = 1;
      this.InsuranceBox.Beneficiary = "";
      this.InsuranceBox.AmountCost = null;
      this.Insurance.AmountCost = null; //清空保险费用

      this.isInsurFee = false;

      this.isInsurBox = false;
      this.isBuyInsur = false;
    },
    clkEditInsur() {
      //编辑
      this.InsuranceBox.BuyAmount = this.Insurance.BuyAmount;
      this.InsuranceBox.BenefitType = this.Insurance.BenefitType;
      this.InsuranceBox.Beneficiary = this.Insurance.Beneficiary;
      this.InsuranceBox.AmountCost = this.Insurance.AmountCost;

      this.isInsurBox = true;
    },
    //理赔条款弹框
    toggleModal() {
      this.$refs.claimRef.clkOpenBox();
    },

    blurMsgInsur() {
      //投保金额输入后移除红色提示
      if (this.InsuranceBox.BuyAmount) {
        this.InsuranceBox.msgInsur = "";
      }
      //货物价值
      if (
        this.BondCost &&
        this.OrderExt.BondValue &&
        this.InsuranceBox.BuyAmount > this.OrderExt.BondValue
      ) {
        this.InsuranceBox.msgInsur =
          "The insured amount shall not exceed the declared value!";
        return false;
      }
    },
    msgTypeInsur() {
      if (this.InsuranceBox.Beneficiary) {
        this.InsuranceBox.msgTypeInsur = "";
      }
    },
    //货物保险弹框
    insurBoxBtn() {
      //购买保险弹框确定按钮
      if (!this.InsuranceBox.BuyAmount) {
        this.InsuranceBox.msgInsur = "Required";
        return false;
      }
      var re = /^\d+(?=\.{0,1}\d+$|$)/;
      if (this.InsuranceBox.BuyAmount != "") {
        if (!re.test(this.InsuranceBox.BuyAmount)) {
          this.InsuranceBox.msgInsur = "Required";
          return false;
        }
      }
      //货物价值
      if (
        this.BondCost &&
        this.OrderExt.BondValue &&
        this.InsuranceBox.BuyAmount > this.OrderExt.BondValue
      ) {
        this.InsuranceBox.msgInsur =
          "The insured amount shall not exceed the declared value!";
        return false;
      }

      if (!this.InsuranceBox.Beneficiary) {
        this.InsuranceBox.msgTypeInsur = "Required";
        return false;
      }

      this.Insurance.BuyAmount = this.InsuranceBox.BuyAmount;
      this.Insurance.Beneficiary = this.InsuranceBox.Beneficiary;
      this.Insurance.AmountCost = this.insurCost;

      this.isInsurFee = true;

      this.isBuyInsur = true; //确定购买保险
      this.isInsurBox = false;
    },
    //货物保险弹框取消按钮
    clkInsurClose() {
      this.InsuranceBox.BuyAmount = null;
      this.InsuranceBox.Beneficiary = "";
      this.InsuranceBox.msgInsur = "";
      this.InsuranceBox.msgTypeInsur = "";
      this.isInsurBox = false;
    },
    //------------------------------- 报关服务 ---------------------------------//

    //是否购买bond费用
    changBuyBong() {
      if (this.OrderExt.IsDestCustoms == 1) {
        this.isBuyBondEd = false;
        this.BondCost = null;
        this.isBondFee = false;
        this.OrderExt.IsBond = false; //是否购买Bond
        this.OrderExt.BondValue = 0;
        //如果选择不够买清关服务，去掉目的地清关服务费用
        this.LstDestFee = [];
        if (this.LstDestFeePackup.length > 0) {
          this.LstDestFeePackup.forEach(k => {
            if (k.FeeType == 3) {
              this.LstDestFee.push(k);
            }
          });
        }
      }
      if (this.OrderExt.IsDestCustoms == 2) {
        if (this.LstDestFeePackup.length > 0) {
          this.LstDestFeePackup.forEach(e => {
            if (e.FeeType == 4) {
              this.LstDestFee.push(e);
            }
          });
        }
        //console.log('sdsd ' + JSON.stringify( this.LstDestFee));
      }
    },

    //购买目的地清关服务bond，购买按钮
    clkBuyBondBtn() {
      if (this.Insurance.BuyAmount && this.Insurance.AmountCost) {
        this.OrderExt.BondValue = this.Insurance.BuyAmount;
      }
      this.isBondBox = true;
    },
    clkEditBond() {
      //编辑bond
      this.isBondBox = true;
    },
    clkCancelBond() {
      //取消购买bond
      this.OrderExt.BondValue = 0;
      (this.BondCost = 0), (this.isBondFee = false); //取消购买不显示在预估费用列表中
      this.isBuyBondEd = false;
      this.OrderExt.IsBond = false; //是否购买Bond
    },
    //-------购买bond弹框
    closeBond() {
      if (this.OrderExt.BondType == 1) {
        this.OrderExt.BondValue = Number(JSON.parse(this.BondValBk));
      }
      //this.OrderExt.BondValue=null
    },
    blurBondVal() {
      if (this.OrderExt.BondValue) {
        this.isGoodsVal = false;
      } else if (!this.OrderExt.BondValue) {
        this.isGoodsVal = true;
      }
    },
    clkBondBtn() {
      //弹框选择按钮：1次有效按钮
      if (!this.OrderExt.BondValue) {
        this.isGoodsVal = true;
        return false;
      }
      var re = /^\d+(?=\.{0,1}\d+$|$)/;
      if (this.OrderExt.BondValue != "") {
        if (!re.test(this.OrderExt.BondValue)) {
          this.isGoodsVal = true;
          return false;
        }
      }
      this.BondValBk = JSON.stringify(this.OrderExt.BondValue); //备份货物价值
      this.BondCost = this.bondFee;
      this.isBondFee = true;
      this.isBuyBondEd = true;
      this.OrderExt.IsBond = true; //是否购买Bond
      this.OrderExt.BondType = 1; //购买Bond的类型 1:1次有效  2:1年有效
      this.isBondBox = false;
    },
    clkBondYearsBtn() {
      //弹框选择按钮：1年有效按钮
      this.BondCost = 500;
      this.isBondFee = true;
      this.isBuyBondEd = true;
      this.OrderExt.IsBond = true; //是否购买Bond
      this.OrderExt.BondType = 2; //购买Bond的类型 1:1次有效  2:1年有效
      this.OrderExt.BondValue = 0;
      this.BondValBk = null;
      this.isBondBox = false;
    },
    //---------随机文件
    randomFileListAPI() {
      // 上一次提交订单后的选择
      let fileTypeOldChoose = JSON.parse(getCookie('airEditFileType'))
      console.log(fileTypeOldChoose, "fileTypeOldChoose");
      //货物随机文件接口
      let that = this;
      this.api.param = {};
      // this.api.url=this.$api02+"/api/EbayCustomer/SysAccompany/Query";
      this.api.url = this.$api04 + "/Air/api/SysAccompany/Query";
      post(this.api.url).then(function (res) {
        that.randomFileList = res.Results;
        that.randomFileList.forEach(e => {
          Vue.set(e, "chkValue", false);
        });
        console.log(that.CargoDocList, that.randomFileList);
        if (that.CargoDocList.length > 0) {
          that.CargoDocList.forEach(doc => {
            that.randomFileList.forEach(g => {
              if (doc.AccompanyDocKey == g.AccompanyDocKey) {
                Vue.set(g, "chkValue", true);
              }

              if (doc.FileName == "Other Accompanying Documents") {
                that.OtherDocName = doc.DocName;
              }
            });
          });
        }
        if (fileTypeOldChoose.length > 0) {
          that.fileSwitch = true
          fileTypeOldChoose.forEach(doc => {
            that.randomFileList.forEach(g => {
              if (doc.AccompanyDocKey == g.AccompanyDocKey) {
                Vue.set(g, "chkValue", true);
              }
              if (doc.FileName == "Other Accompanying Documents") {
                that.OtherDocName = doc.DocName;
              }
            });
          });
        }
      });

    },
    changDocItem(msg) {
      //随机文件选中值改变
      msg.chkValue = !msg.chkValue;
    },
    //附件上传
    handleBatExceed(files, fileList) {
      //限制最大个数的
      this.$message.warning("Upload up to 5 attachments");
    },
    beforeBatUpload(file, fileList) {
      //上传文件之前做验证
      const extension =
        " .jpg, .jpeg, .gif, .png, .bmp, .pic, .doc, .docx, .rar, .xls, .xlsx, .pdf, .zip, .7z, ";
      var fileName = file.name;
      var ext =
        fileName.substring(fileName.lastIndexOf("."), fileName.length) + ", ";

      if (extension.indexOf(ext) == -1) {
        this.$confirm(
          "The imported file can only be in " + extension + " format!",
          "",
          {
            customClass: "custom-message-box", //自定义添加Class
            confirmButtonText: "Confirm",
            cancelButtonText: "Cancel",
            cancelButtonClass: "btn-custom-cancel", //添加class,更换删除和取消按钮位置
            closeOnClickModal: false, //是否可通过点击遮罩关闭 MessageBox
            showCancelButton: false, //去掉取消按钮
            showClose: false, //去掉右上角的取消（X）
            // type: 'warning',
            center: true
          }
        )
          .then(() => { })
          .catch(() => { });
        return false;
      }
      const isLt2M = file.size / 1024 / 1024 < 10;
      const isLtZeroM = file.size / 1024 / 1024 > 0;
      if (!isLt2M) {
        this.$confirm("Upload file size is over 10M！", "", {
          customClass: "custom-message-box", //自定义添加Class
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          cancelButtonClass: "btn-custom-cancel", //添加class,更换删除和取消按钮位置
          closeOnClickModal: false, //是否可通过点击遮罩关闭 MessageBox
          showCancelButton: false, //去掉取消按钮
          showClose: false, //去掉右上角的取消（X）
          // type: 'warning',
          center: true
        })
          .then(() => { })
          .catch(() => { });
        return false;
      }
      if (!isLtZeroM) {
        this.$confirm("The file size is 0kb, please re-upload!", "", {
          customClass: "custom-message-box", //自定义添加Class
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          cancelButtonClass: "btn-custom-cancel", //添加class,更换删除和取消按钮位置
          closeOnClickModal: false, //是否可通过点击遮罩关闭 MessageBox
          showCancelButton: false, //去掉取消按钮
          showClose: false, //去掉右上角的取消（X）
          // type: 'warning',
          center: true
        })
          .then(() => { })
          .catch(() => { });
        return false;
      }
      //上传文件名不能超多100个字符
      if (fileName.length > 100) {
        this.$confirm(
          "The file name is over 100 characters, please re-upload!",
          "",
          {
            customClass: "custom-message-box", //自定义添加Class
            confirmButtonText: "Confirm",
            cancelButtonText: "Cancel",
            cancelButtonClass: "btn-custom-cancel", //添加class,更换删除和取消按钮位置
            closeOnClickModal: false, //是否可通过点击遮罩关闭 MessageBox
            showCancelButton: false, //去掉取消按钮
            showClose: false, //去掉右上角的取消（X）
            // type: 'warning',
            center: true
          }
        )
          .then(() => { })
          .catch(() => { });
        return false;
      }
      return true;
    },
    customUpload(file) {
      // let url = this.$api04 + "/File/api/FileUpload/UploadFile";
      let url = this.$api04 + '/File/api/FileHandle/UploadFile'

      this.fileUpload(url, file, 0);
    },
    //上传文件
    fileUpload(uploadUrl, option, chunk) {
      console.log(uploadUrl, option);
      let file = option.file;
      //每次上传文件的大小
      let chunkSize = 1024 * 1024;
      //最大上传大小  默认100M
      let maxSize = 1024 * 1024 * 100;
      let maxChunk = Math.ceil(file.size / chunkSize);
      let formData = new FormData();

      // //将文件进行分段
      // let fileSize = file.size;
      // if (fileSize > maxSize) {
      //   this.$message.error("文件大小不能超过" + maxSize / 1024 / 1024 + "M");
      //   return;
      // }

      // //当前上传进度
      // let currentPercent = parseInt((chunk / maxChunk) * 100);
      // option.onProgress({ percent: currentPercent }); //进度条
      formData.append("file", file);
      formData.append("UploadType", 8);
      formData.append("PathName", "air/airOrder");
      formData.append("IsTempFile", false);
      post(uploadUrl, formData).then(resJson => {
        if (resJson.Results.UploadPath) {
          this.fileList1.push({
            FIlePath: resJson.Results.UploadPath,
            OriginaFilelName: file.name,
            BuildFileName: this.$route.query.ord + "_" + file.name,
            AttachType: 6, //1：提单附件，2：报关底单，3：保险凭证，4：其他，5：订单资料，6，客户上传附件，通过接口上传的，没有固定哪个类型，都当订单资料类型处理
            UploadType: 0 //上传人.0：客户上传，1：后台上传，2：供应商上传
          });
        }
      });
    },


    //附件上传成功
    batAttSuccess(file, fileList) {
      if (file.Results.UploadPath) {
        this.fileList1.push({
          FIlePath: file.Results.UploadPath,
          OriginaFilelName: fileList.name,
          BuildFileName: this.$route.query.ord + "_" + fileList.name,
          AttachType: 6, //1：提单附件，2：报关底单，3：保险凭证，4：其他，5：订单资料，6，客户上传附件，通过接口上传的，没有固定哪个类型，都当订单资料类型处理
          UploadType: 0 //上传人.0：客户上传，1：后台上传，2：供应商上传
        });
      }
      //this.expShow01=false
    },
    //删除
    clkDelFile(index) {
      this.fileList1.splice(index, 1);
    },

    //-----------------------预估费用--------------//
    //调用查价接口获取取件费，目的地费用，必收附加费
    async getWillReapFee(infos) {
      let that = this;
      //console.log("=====lllll", that.airPirce);
      let planTime = "";
      if (!infos.Order.PlanDeliveryTime) {
        planTime = new Date(this.PlanDeliveryTime2).Format("yyyy-MM-dd");
      } else {
        planTime = new Date(infos.Order.PlanDeliveryTime).Format("yyyy-MM-dd");
      }


      // 判断是否是以条款（FCA/FOB等）下单，即用户是海外同行 客户归属类型 0：直客，1：国内同行，2：海外同行
      that.userType = JSON.parse(sessionStorage.getItem("customerInfos"))
        .CustomerOwnerType;
      if (that.userType == 2) {
        // 海外同行
        this.api.param = {
          skip: 0,
          take: 20,
          //   orderBy: this.orderSort?this.orderSort:"comprehensive",
          //   // orderByDesc: "aa",
          customerID: infos.Order.CustomerID, //客户id
          customerOwnerType: that.userType, //客户归属类型 0：直客，1：国内同行，2：海外同行
          startCityKey: infos.OrderExt.StartCityKey, //起运城市Key
          queryGoodType: 2, //货件查询类型 （1：按详细货物，2：按总的货物信息）

          orderServiceType: infos.Order.OrderServiceType, //服务类型 1：门到门，2：门到机场，3：机场到机场，4：机场到门，5：FOB，6：EXW，7：FCA
          goodsReadyTime: planTime, //"2021-06-24T06:25:09.016Z",//货好时间
          channelKey: infos.Order.AirChannelKey, //渠道Key
          channelOwnerType: infos.Order.OrderAddType, //渠道所属类型 0：普通渠道，1：大货渠道

          isDestCustoms: that.OrderExt.IsDestCustoms == 1 ? false : true, //是否需要目的地清关服务
          isBond: infos.OrderExt.IsBond, //是否购买Bond
          bondType: infos.OrderExt.BondType, //购买Bond类型 （1：1次有效，2：1年有效） （只有购买了Bond才有意义）
          bondValue: infos.OrderExt.BondValue, //Bond货物价值 （只有购买Bond且选择1次有效时才有意义）

          startAirportCodeList: [infos.Order.DepartureCode], //起运机场列表 默认5大机场（上海、广州、香港、深圳、北京）
          destAirportCodeList: [infos.Order.DestinationCode], // 目的机场列表
          arrivalType: infos.Order.AirArrivalType, // 到达类型
          transferAirportCode: infos.Order.TransferAirport, // 中转机场
          airCompanyKeyList: null, //航空公司Key
          weight: Number(infos.Order.Weight),
          volume: Number(infos.Order.VolumeCBM),
          quantity: Number(infos.Order.PackageQuanlity), //件数
          cargoTypeIDList: infos.Order.CargoIDs.split(","), //货物种类ID
          isShowDisableChannel: true, //是否查询禁用的空运渠道
          "platformType": "web",
          "isLogin": true,
          "entrance": "Air Freight"
        };
        // 如果不需要目的地清关服务
        if (!this.api.param.isBond) {
          delete this.api.param.bondType;
          delete this.api.param.bondValue;
        }
        this.api.url = this.$api04 + "/Air/api/AirCalculation/QueryPriceEn";
      } else {
        this.api.url =
          this.$api01 + "/api/InfoCustomer/AirCalculation/QueryPriceEn";
        this.api.param = {
          OrderServiceType: infos.Order.OrderServiceType, //服务类型 （1：门到门，2：门到机场，3：机场到机场，4：机场到门）
          QueryGoodType: 2, //货件查询类型 （1：按详细货物，2：按总的货物信息）
          ChannelOwnerType: infos.Order.OrderAddType, //渠道所属类型 （0：普通渠道，1：大货渠道）
          StartCityKey: infos.OrderExt.StartCityKey, //起始城市Key （服务类型=[1：门到门，2：门到机场]，时用到),
          StartCityAreaKey: infos.OrderExt.StartCityAreaKey, //起始区域key （服务类型=[1：门到门，2：门到机场]，时用到）
          DestCountryKey: infos.OrderExt.DestCountryKey, //目的国家key （服务类型=[1：门到门，4：机场到门]，时用到） ,
          DestCityKey: infos.OrderExt.DestCityKey, //目的城市key （服务类型=[1：门到门，4：机场到门]，时用到） ,

          Destination: infos.OrderExt.DestAddressDesc,

          LstStartAirPortCode3: [infos.Order.DepartureCode], //起飞机场三字码
          LstDestAirPortCode3: [infos.Order.DestinationCode], //目的机场三字码

          GoodsReadyTime: planTime, //货好时间
          IsDestCustoms: that.OrderExt.IsDestCustoms == 1 ? false : true, //是否需要目的地清关服务
          IsBond: infos.OrderExt.IsBond, //是否购买Bond
          BondType: infos.OrderExt.BondType, //购买Bond类型 （1：1次有效，2：1年有效） （只有购买了Bond才有意义）
          BondValue: infos.OrderExt.BondValue, //Bond货物价值 （只有购买Bond且选择1次有效时才有意义）

          TotalQuanlity: Number(infos.Order.PackageQuanlity), //总数量
          TotalWeight: Number(infos.Order.Weight), //总重量
          TotalCBM: Number(infos.Order.VolumeCBM), //总体积
          ArrivalType: infos.Order.AirArrivalType, //中转类型
          TransferAirport: infos.Order.TransferAirport, //中转机场
          CargoTypeIDs: infos.Order.CargoIDs.split(","), //货物种类
          AirChannelKey: infos.Order.AirChannelKey, //空运渠道key
          // DestSvcID:infos.OrderExt.DestSvcID,//目的地服务ID
          // THChannelKey:infos.OrderExt.THChannelKey,//取件渠道key
          //IsSHReport:'',//上海起飞，是否有化工报告
          IsQueryDisableAirChannel: true, //是否查询禁用的空运渠道
          skip: 0,
          take: 20,
          "platformType": "web",
          "isLogin": true,
          "entrance": "Air Freight"
        };
      }
      await post(this.api.url, this.api.param).then(function (res) {
        if (res.IsOK == true && res.Results) {
          if (infos.Order.Status == 0 && res.Results.List.length > 0) {
            that.PicreInfo = res.Results.List[0];
            //运费
            //console.log("=====22222", infos.Order);
            that.airWeight = infos.Order.ChargeWeight;//res.Results.List[0].AirChargeWeight;
            that.airPirce = infos.Order.OrderPrice //res.Results.List[0].AirPrice;
            that.airTotolCost = infos.Order.OrderTrafficAmount    //res.Results.List[0].AirTracficFee;
            //提货费+派送费
            that.THAmount = res.Results.List[0].THAmount;
            that.THChargeWeight = res.Results.List[0].THChargeWeight;
            that.DeliverInfo.PSPrice = res.Results.List[0].DeliverAmount;
            that.DeliverInfo.PSUnitPrice = res.Results.List[0].DeliverPrice;
            that.DeliverInfo.PSWeight = res.Results.List[0].DeliverChargeWeight;
            //当服务类型是门到门，门到机场，取件费为空的时候，渠道禁用
            if (
              infos.Order.OrderServiceType == 1 ||
              infos.Order.OrderServiceType == 2
            ) {
              if (
                !res.Results.List[0].THAmount ||
                res.Results.List[0].THAmount == 0
              ) {
                that
                  .$confirm(
                    "This channel is no longer effective, please change the channel and place an order!",
                    "",
                    {
                      customClass: "custom-message-box", //自定义添加Class
                      confirmButtonText: "Confirm",
                      cancelButtonText: "Cancel",
                      dangerouslyUseHTMLString: true,
                      cancelButtonClass: "btn-custom-cancel", //添加class,更换删除和取消按钮位置
                      closeOnClickModal: false, //是否可通过点击遮罩关闭 MessageBox
                      showCancelButton: false, //去掉取消按钮
                      showClose: false, //去掉右上角的取消（X）
                      // type: 'warning',
                      center: true
                    }
                  )
                  .then(() => {
                    that.$router.push({
                      path: "/air/airList"
                    });
                  })
                  .catch(() => { });
                return false;
              }
            }
            //当服务类型是门到门，机场到门，取件费为空的时候 派送费等于0的时候，渠道禁用
            if (
              infos.Order.OrderServiceType == 1 ||
              infos.Order.OrderServiceType == 4
            ) {
              if (
                !res.Results.List[0].DeliverAmount ||
                res.Results.List[0].DeliverAmount == 0
              ) {
                that
                  .$confirm(
                    "This channel is no longer effective, please change the channel and place an order!",
                    " ",
                    {
                      customClass: "custom-message-box", //自定义添加Class
                      confirmButtonText: "Confirm",
                      cancelButtonText: "Cancel",
                      dangerouslyUseHTMLString: true,
                      cancelButtonClass: "btn-custom-cancel", //添加class,更换删除和取消按钮位置
                      closeOnClickModal: false, //是否可通过点击遮罩关闭 MessageBox
                      showCancelButton: false, //去掉取消按钮
                      showClose: false, //去掉右上角的取消（X）
                      // type: 'warning',
                      center: true
                    }
                  )
                  .then(() => {
                    that.$router.push({
                      path: "/air/airList"
                    });
                  })
                  .catch(() => { });
                return false;
              }
            }
          }
          //alert(res.Results.List.length)
          if (res.Results.List.length == 0) {
            that
              .$confirm(
                "This channel is no longer effective, please change the channel and place an order!",
                " ",
                {
                  customClass: "custom-message-box", //自定义添加Class
                  confirmButtonText: "Confirm",
                  cancelButtonText: "Cancel",
                  dangerouslyUseHTMLString: true,
                  cancelButtonClass: "btn-custom-cancel", //添加class,更换删除和取消按钮位置
                  closeOnClickModal: false, //是否可通过点击遮罩关闭 MessageBox
                  showCancelButton: false, //去掉取消按钮
                  showClose: false, //去掉右上角的取消（X）
                  // type: 'warning',
                  center: true
                }
              )
              .then(() => {
                that.$router.push({
                  path: "/air/airList"
                });
              })
              .catch(() => { });
            return false;
          }

          // //必收附加费
          if (res.Results.List.length > 0 && res.Results.List[0].LstAirFee) {
            res.Results.List[0].LstAirFee.forEach(e => {
              that.orderFeeList.push(e);
            });
          }
          //目的地清关费  如果目的地清关服务选择否，则不显示清关服务费用
          if (res.Results.List[0].LstDestFee) {
            if (
              res.Results.List.length > 0 &&
              res.Results.List[0].LstDestFee.length > 0
            ) {
              that.LstDestFeePackup = res.Results.List[0].LstDestFee; //备份一份全部的数据 报关目的地清关服务费
              //alert('sd  '+ that.OrderExt.IsDestCustoms)
              res.Results.List[0].LstDestFee.forEach(e => {
                if (that.OrderExt.IsDestCustoms == 1 && e.FeeType == 3) {
                  that.LstDestFee.push(e);
                } else if (
                  that.OrderExt.IsDestCustoms == 2 &&
                  (e.FeeType == 3 || e.FeeType == 4)
                ) {
                  that.LstDestFee.push(e);
                }
              });
            }
          }

        }
      });
    },

    judgetUnit(val) {
      if (val == "0") return "B\\L";
      if (val == "1") return "CBM";
      if (val == "2") return "Pcs";
      if (val == "3") return "KG";
      if (val == "4") return "page";
      if (val == "5") return "B\\L";
      if (val == "6") return "Day";
      if (val == "7") return "Time";
      if (val == "8") return "Unit";
      return "";
    },
    //-------------------------------------下一步，派单------------------------------//
    nextLastBtn() {
      //验证方法

      let isCheck = this.getCheckForm();
      if (!isCheck) {
        return false;
      }
      //电池种类是否选择
      if (this.includeCargos() && this.batStrs.length <= 0) {
        this.isShowbatStrs = true;
        return false;
      } else {
        this.isShowbatStrs = false;
      }

      this.isShowPickUpGoods = true;
      if (!this.Order.PlanDeliveryTime) {
        this.Order.PlanDeliveryTime = this.PlanDeliveryTime2;
      }
    },
    gobackBtn() {
      this.isShowPickUpGoods = false;
    },

    //目的地派送信息
    clkReceiveBtn(code) {
      //点击收件地址库按钮
      this.isCode = code;
      this.$refs.receiveBox.clkDialog();
    },

    //-----------------验证-----------------------------------//
    //数字验证
    checkNum(ctrValue) {
      if (ctrValue) {
        ctrValue = ctrValue.replace(/[^\d\.]/g, "");
        if (ctrValue.indexOf(".") > -1) {
          let s = ctrValue.substring(ctrValue.indexOf(".") + 1);
          if (s.length > 2) {
            ctrValue = ctrValue.substring(0, ctrValue.indexOf(".") + 3);
          }
          if (s.indexOf(".") > -1) {
            ctrValue = ctrValue.substring(0, ctrValue.length - 1);
          }
        }

        //获取小数点前面的值
        let arr = ctrValue.split(".");
        let le = arr[0].length;

        if (le > 8) {
          let int = arr[0].substring(0, 8);
          if (ctrValue.indexOf(".") > -1) {
            ctrValue = int + "." + arr[1];
          } else {
            ctrValue = int;
          }
        }
        return ctrValue;
      }
    },

    //-----------------提交订单-----------------------------------//

    clkSubmitOrders() {
      //验证方法
      // if (this.chekReceive == "1") {
      //   if (!this.ContactInfo.NotifyCompany || !this.ContactInfo.NofityName || !this.ContactInfo.NotifyTelephone || !this.ContactInfo.NotifyAddress) {
      //     this.chekReceive = "2"
      //   }
      // }
      let isCheck = this.getCheckForm();
      console.log(isCheck, "isCheck");
      if (!isCheck) {
        return false;
      }
      //电池种类是否选择
      if (this.includeCargos() && this.batStrs.length <= 0) {
        this.isShowbatStrs = true;
        return false;
      } else {
        this.isShowbatStrs = false;
      }

      this.clkSubmitOrdersAPI();
    },
    clkSubmitOrdersAPI() {
      let that = this;
      //是否一起提货
      //this.mergeInfo.THOrderNo ? this.THInfo.IsMultiTH=true: this.THInfo.IsMultiTH=false
      //  console.log('THOrderNo  '  + JSON.stringify(this.mergeInfo.THOrderNo))
      //  console.log('IsMultiTH  '  + JSON.stringify(this.THInfo.IsMultiTH))

      let OrdSum = 0;
      if (!this.IsWCA) {
        OrdSum = Number(that.costAll + that.BankCharge).toFixed(2); //预估总费用，包含银行手续费
      } else {
        OrdSum = Number(that.costAll).toFixed(2);
      }

      if (!this.Order.PlanDeliveryTime) {
        this.Order.PlanDeliveryTime = this.PlanDeliveryTime2;
      }
      this.api.param = {
        Order: {
          Id: this.Order.Id, //订单号
          RefNO: this.Order.RefNO, //
          DeclaredAmount: Number(this.OrderExt.BondValue), //申报价值
          BatteryInfo: this.batStrs.join(","), //电池信息
          PlanDeliveryTime: new Date(this.Order.PlanDeliveryTime).Format(
            "yyyy-MM-dd"
          ), //货好时间 ,
          OrderAmount: OrdSum, //下单时的金额 运费+必收附加费+选择的附加费 ,

          ShippingMark: this.userType == 2 || this.userType == 3 ? 'According to the booking' : this.Order.ShippingMark, //唛头
          GoodsName: this.userType == 2 || this.userType == 3 ? 'According to the booking' : this.Order.GoodsName, //品名
          Remarks: this.Order.Remarks //备注
        },
        EditOrderExt: {
          OrderCostUnitPrice: this.OrderExt.OrderCostUnitPrice, //成本单价(目标币种)
          OrderCostCurrency: 2,//币种 英文网传美元
        },
        PriceDetail: this.PicreInfo, //查价信息全部返回
        IsWithOtherTh: this.THInfo.IsMultiTH, //是否与其他货一起提货 ,

        ContactInfo: this.ContactInfo, //联系人信息
        PickUpContact: null, //取件联系人对象
        Factory: this.Factory,//工厂信息
        IsSendAddToAddr: this.IsSendAddToAddr, //是否加入到发件人地址库
        IsReceiveAddToAddr: this.IsReceiveAddToAddr, //是否加入到收件人地址库 ,
        IsSaveasDelegate: this.IsSaveasDelegate, //是否保存为空运委托书
        "platform_type": "web",
        "entrance": "Submit AirOrder"
      };
      // 是否需要清关服务
      if (this.OrderExt.IsDestCustoms == 1) {
        this.OrderExt.IsDestCustoms = false;
      } else if (this.OrderExt.IsDestCustoms == 2) {
        this.OrderExt.IsDestCustoms = true;
      }

      this.api.param.OrderExt = this.OrderExt; //扩展表
      // if(this.OrderExt.BondType==1){
      //   this.OrderExt.BondValue=Number (JSON.parse(this.BondValBk))
      // }

      //保险
      this.OrderExt.IsrInsurance = this.isBuyInsur; //是否购买保险

      if (this.OrderExt.IsrInsurance == true) {
        this.api.param.Insurance = this.Insurance;
      } else {
        this.api.param.Insurance = "";
      }

      //随机文件
      if (this.randomFileList) {
        console.log(this.randomFileList, "this.randomFileList");
        let docFile = [];
        this.randomFileList.forEach(k => {
          if (k.chkValue == true) {
            if (
              this.randomFileVal.includes("Other Accompanying Documents") ==
              true
            ) {
              let info = {
                AccompanyDocKey: k.AccompanyDocKey,
                DocName: this.OtherDocName,
                DocDescription: k.Description,
                FileName: k.AccompanyDocName
              };
              docFile.push(info);
            } else {
              let info = {
                AccompanyDocKey: k.AccompanyDocKey,
                DocName: "",
                DocDescription: k.Description,
                FileName: k.AccompanyDocName
              };
              docFile.push(info);
            }
          }
        });
        this.api.param.CargoDocList = this.fileSwitch ? docFile : []; //随机文件
      }
      //附件AttachList
      if (this.fileList1.length > 0) {
        let fileUpArr = [];
        this.fileList1.forEach(e => {
          let info = {
            OriginName: e.OriginaFilelName,
            BuildName: e.BuildFileName,
            Url: e.FIlePath,
            OriginUrl: e.OriginUrl,
            AttachType: e.AttachType, //1：提单附件，2：报关底单，3：保险凭证，4：其他，5：订单资料，6，客户上传附件，通过接口上传的，没有固定哪个类型，都当订单资料类型处理
            UploadType: e.UploadType //上传人.0：客户上传，1：后台上传，2：供应商上传
          };
          fileUpArr.push(info);
        });
        this.api.param.AttachList = fileUpArr;
      } else {
        this.api.param.AttachList = null;
      }
      //
      if (this.Order.Status == 0) {
        this.api.param.DeliverContact = this.DeliverContact; //派送人
        this.api.param.DeliverContact.DestAddressDesc = this.OrderExt.DestAddressDesc;
        if (this.mergeInfo.THOrderNo) {
          this.api.param.THBillNo = this.mergeInfo.THOrderNo; //取件单号
        }
      } else {
        this.api.param.DeliverContact = null; //派送人
        this.api.param.PickUpContact = null; //取件地址
      }
      this.isShowOrderBtn = false;
      //let w=window.open()
      // 判断是否是以条款（FCA/FOB等）下单，即用户是海外同行
      that.userType = JSON.parse(sessionStorage.getItem("customerInfos"))
        .CustomerOwnerType;
      debugger
      if (that.userType == 2) {
        // 海外同行
        this.api.url = this.$api04 + "/Air/api/AirOrderEn/Update";
        // 如果不需要目的地清关服务
        if (!this.api.param.OrderExt.isBond) {
          delete this.api.param.OrderExt.BondType;
          delete this.api.param.OrderExt.BondValue;
        }else{
          this.api.param.OrderExt.BondType = this.api.param.OrderExt.BondType || 0;
          this.api.param.OrderExt.BondValue = this.api.param.OrderExt.BondValue || 0;
        }
        this.api.param.Order.Id = this.Order.WaybillNO;
      } else {
        // this.api.url = this.$api03 + "/api/TradeCustomer/AirOrderEn/Update";
        this.api.url = this.$api04 + "/Air/api/AirOrderEn/UpdateEn";
      }
      post(this.api.url, this.api.param).then(function (res) {
        let stratText = "";
        if (
          that.Order.OrderServiceType == 1 ||
          that.Order.OrderServiceType == 2
        ) {
          stratText =
            that.OrderExt.StartCityNameEn + "," + that.OrderExt.StartProNameEn;
        } else {
          stratText =
            that.Order.DepartureCode + "," + that.Order.DepartureNameEn;
        }

        let endText = "";
        if (
          that.Order.OrderServiceType == 1 ||
          that.Order.OrderServiceType == 4
        ) {
          endText = that.OrderExt.DestAddressDesc;
        } else {
          endText =
            that.Order.DestinationCode + "," + that.Order.DestinationNameEn;
        }

        let Cost = 0;
        if (that.IsWCA) {
          Cost = Number(that.costAll).toFixed(2);
        } else {
          Cost = Number(that.costAll + that.BankCharge).toFixed(2);
        }

        // that.submitOrder(
        //   that.Order.Id,
        //   Cost,
        //   Cost,
        //   "Air Freight",
        //   stratText,
        //   "",
        //   endText,
        //   "",
        //   that.Order.CargoNameEn,
        //   that.Order.Weight,
        //   that.Order.VolumeCBM,
        //   that.Order.PackageQuanlity,
        //   that.Order.OrderWeight,
        //   "",
        //   that.Order.AirChannelName,
        //   that.airTotolCost,
        //   "",
        //   "",
        //   false
        // );

        if (res.IsOK == true) {
          // 存储这次下单选择的随机文件
          setCookie('airEditFileType', JSON.stringify(that.api.param.CargoDocList))
          // 存储Consignee信息
          let ConsigneeInfo = {
            ReceiveCompany: that.ContactInfo.ReceiveCompany,
            ReceiveTaxNO: that.ContactInfo.ReceiveTaxNO,
            ReceiveName: that.ContactInfo.ReceiveName,
            ReceiveTelephone: that.ContactInfo.ReceiveTelephone,
            ReceiveAddress: that.ContactInfo.ReceiveAddress,
          }
          setCookie('airOrderConsigneeInfo', JSON.stringify(ConsigneeInfo))
          that.isShowOrderBtn = true;
          that.$router.push({
            path: "/air/airSucceed",
            query: {
              ord: that.userType == 2 ? that.Order.WaybillNO : that.Order.Id, // 判断是海外同行还是直客
              ordNumCost: OrdSum,
              Qty: that.Order.PackageQuanlity,
              OrderServiceType: that.OrderServiceType
            }
          });
        } else {
          that.isShowOrderBtn = true;
          that
            .$confirm("failed!", "", {
              customClass: "custom-message-box", //自定义添加Class
              confirmButtonText: "Confirm",
              cancelButtonText: "Cancel",
              dangerouslyUseHTMLString: true,
              cancelButtonClass: "btn-custom-cancel", //添加class,更换删除和取消按钮位置
              closeOnClickModal: false, //是否可通过点击遮罩关闭 MessageBox
              showCancelButton: false, //去掉取消按钮
              showClose: false, //去掉右上角的取消（X）
              // type: 'warning',
              center: true
            })
            .then(() => { })
            .catch(() => { });
          return false;
        }
      });
    },
    pickAddr() {
      if (!this.discernInfo) {
        this.discernInfoTip = true
        return false
      }
      this.api.url = this.$api02 + '/api/EbayCustomer/PickupAddr/DiscernEn'
      this.api.param = {
        "textbox": this.discernInfo
      }
      fetch(this.api.url, this.api.param).then(res => {
        if (res.IsOK) {
          this.Factory.FactoryContactName = res.Results.FullName;
          this.Factory.FactoryContactTelephone = res.Results.Phone;
          this.Factory.FactoryContactEmail = res.Results.Mailbox;
          this.Factory.FactoryAddress = res.Results.Address;
        }
      });
      // 结束
      this.discernBox = false
    },
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/userCenter/air/airEdit.js